import AmarjeetResume from '../assets/pdf/AmarjeetResume.PDF'

export const headerData = {
    name: 'Amarjeet Maurya',
    title: "Full Stack Web Developer",
    desciption:"I love to code, build things & solve problems. Developing an idea or concept into an impactful product, which is going to change people's lives is something that really excites me. For fun, I like reading books, playing football & cricket.",
    image: 'https://media-exp2.licdn.com/dms/image/C4D03AQGkwLS8aLlItQ/profile-displayphoto-shrink_400_400/0/1647952441204?e=1661990400&v=beta&t=ZffLraL1C7zHs6Cu_CsFPS9GOGl-Q4WHtePvZQZ0py4',
    resumePdf: AmarjeetResume
}
